import Request from "../../../utils/Request"
import { AxiosResponse } from "axios"

/**
 * @param data
 * @returns {Promise<AxiosResponse<T>>}
 * @constructor
 */
const GetKeyStats = (data:any[] = false): Promise<AxiosResponse<T>> => {
	return Request.post("/advisors/ifa/key-stats", data);
}

/**
 * @returns {Promise<AxiosResponse<any>>}
 */
export default GetKeyStats
